import EvolutionSplit from './EvolutionSplit.vue';
import KpiCard from './KpiCard.vue';
export default {
  name: 'TabbedKpiCards',
  components: {
    KpiCard,
    EvolutionSplit
  },
  props: {
    kpi: Object,
    loading: Boolean
  }
};